module.exports = __webpack_public_path__ + "a088e300e1d3b774eb9e0b1b770b8b57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/spinner-ring.svg
// module id = 783
// module chunks = 0